import React from 'react'

import PropTypes from 'prop-types'

import I18n from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'

import { Container, MainText, HeaderText } from './styles'

const ErrorModal = (props) => {
  const { id, open, handleClose, message, title } = props

  return (
    <Modal
      id={ id }
      open={ open }
      escape={ false }
      hideHeader
      maxWidth="xs"
    >
      <Container>

        <HeaderText>
          {title}
        </HeaderText>

        {message && (
          <MainText>
            {message}
          </MainText>
        )}

        <Button
          id="ok-error"
          onClick={ handleClose }
          style={ { minWidth: 100, marginTop: 10 } }
          variant="text"
          color="text"
        >
          <I18n>close</I18n>
        </Button>

      </Container>
    </Modal>
  )
}

ErrorModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
}

ErrorModal.defaultProps = {
  message: null,
  title: null
}

export default ErrorModal
